exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css"), undefined);

// module
exports.push([module.id, "._1Roz78b0fnVluVaBXTcOm7 {\n  height: 100%;\n  background-color: " + require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css").locals["white"] + ";\n  position: relative;\n}\n._2t1MswJZj203zPRMi06KWI {\n  stroke: #fff;\n  stroke-width: 1px;\n}\n\n._87n0JdfTCswkg34SJhXPZ {\n  opacity: 0.2;\n}\n\n._3B9PLCoAWZJ7HCd2iiB6-1 {\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"white": "" + require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css").locals["white"] + "",
	"graph": "_1Roz78b0fnVluVaBXTcOm7",
	"circle": "_2t1MswJZj203zPRMi06KWI",
	"unselected": "_87n0JdfTCswkg34SJhXPZ",
	"selected": "_3B9PLCoAWZJ7HCd2iiB6-1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Graphs/Graph.css
// module id = 99
// module chunks = 23